import React, { Component } from 'react';

import PrivacyPage from '../sections/PrivacyPage'

class Privacy extends Component {

    render() {
        return (
            <div>
                <PrivacyPage />
            </div>
        )
    }

}
export default Privacy